<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="TOC"><a href="#/About_Interurban_Railways">About the Interurban Railways</a></p>
<p class="TOC"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="TOC"><a href="#/Introduction">Introduction</a></p>
<p class="TOC1"><a href="#/Chapter1#C1">1. A Few Definitions</a></p>
<p class="TOC"><a href="#/Chapter2#C2">2. Mountaineer Madman</a></p>
<p class="TOC"><a href="#/Chapter3#C3">3. Captain Joe Byrd Cemetery</a></p>
<p class="TOC"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. Revenge of the Motorman</span></p>
<p class="TOC"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. The Death of Larkin George</span></p>
<p class="TOC"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Railway Employees: Into the Jaws of Death</span></p>
<p class="TOC"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Texas Electric Railway Rule Book No. 1</span></p>
<p class="TOC"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Trains, Pains and Automobiles</span></p>
<p class="TOC"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. The 1914 Woodlake Interurban Wreck</span></p>
<p class="TOC"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. The Mystery of John H. Dillehay’s Death</span></p>
<p class="TOC"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. Teenage Killer</span></p>
<p class="TOC"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. Anarchy in El Paso</span></p>
<p class="TOC"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. Train Wreck at Waterman</span></p>
<p class="TOC"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. Jefferson, Texas</span></p>
<p class="TOC"><span href="#/Chapter15#C15" title="Link target outside of Sample">15. Disorder on the Border</span></p>
<p class="TOC"><span href="#/Chapter16#C16" title="Link target outside of Sample">16. The Valley of Death</span></p>
<p class="TOC"><span href="#/Chapter17#C17" title="Link target outside of Sample">17. Porter Perils</span></p>
<p class="TOC"><span href="#/Chapter18#C18" title="Link target outside of Sample">18. June 10, 1907: Blame It on the Moon</span></p>
<p class="TOC"><span href="#/Chapter19#C19" title="Link target outside of Sample">19. Families Shattered in Plano</span></p>
<p class="TOC"><span href="#/Chapter20#C20" title="Link target outside of Sample">20. The Cost of Cost Cutting</span></p>
<p class="TOC"><span href="#/Chapter21#C21" title="Link target outside of Sample">21. Miscellaneous Mayhem</span></p>
<p class="TOC"><span href="#/Chapter22#C22" title="Link target outside of Sample">22. Ever-Present Danger</span></p>
<p class="TOC1"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="TOC"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
<p class="TOC"><span href="#/About_Plano_Conservancy" title="Link target outside of Sample">About the Plano Conservancy for Historic Preservation Inc.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?2db2fc82